import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/sonner";
import { LogOut, LogIn } from "lucide-react";
import LoginModal from "@/components/auth/LoginModal";

const UserHeader: React.FC = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  
  // Verificar se o usuário está logado ao carregar o componente
  useEffect(() => {
    // Verificar status inicial de login
    const loggedInStatus = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedInStatus);
    
    // Verificar status a cada 2 segundos para atualizar o botão caso o status mude
    const interval = setInterval(() => {
      const currentStatus = localStorage.getItem('isLoggedIn') === 'true';
      setIsLoggedIn(currentStatus);
    }, 2000);
    
    return () => clearInterval(interval);
  }, []);
  
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
    toast.success("Sessão encerrada com sucesso!");
    // Redirecionamento para a página inicial após logout
    setTimeout(() => {
      navigate("/");
    }, 1000);
  };
  
  const handleLoginClick = () => {
    setIsLoginModalOpen(true);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    toast.success("Login realizado com sucesso!");
  };

  return (
    <div className="w-full bg-[#0e7cb4] text-white flex justify-between items-center p-4">
      <div className="flex items-center gap-3">
        <img 
          src="/lovable-uploads/f39d7417-003f-492e-a50c-3da391f017a6.png" 
          alt="Banclima Logo" 
          className="h-8" 
        />
        <div className="text-lg font-bold">
          PROJETOS DE IMPACTO SOCIOCLIMÁTICO
        </div>
      </div>
      
      {isLoggedIn ? (
        // Botão de SAIR (quando usuário está logado)
        <Button 
          variant="ghost" 
          className="text-white hover:text-white hover:bg-[#0a5a83] flex items-center gap-2"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" />
          SAIR
        </Button>
      ) : null}
      
      {/* Modal de Login */}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onSuccess={handleLoginSuccess}
      />
    </div>
  );
};

export default UserHeader;
